import { render, staticRenderFns } from "./ContactTypeForm.vue?vue&type=template&id=32045a82"
import script from "./ContactTypeForm.vue?vue&type=script&lang=js"
export * from "./ContactTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports